import apiClient from "../../../utils/interceptor";
import {
  ApiResponse,
  CommpanyMachineData,
  AttachMachineResponse,
  MachineParams,
} from "./interface";
import { API_URLS } from "../../../constants";

// Helper to get auth token
const getAuthToken = (): string | null => {
  return localStorage.getItem("auth_token");
};

export const getMachinesByCompanyID = async (
  companyId: string
): Promise<ApiResponse<CommpanyMachineData[]>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.get<ApiResponse<CommpanyMachineData[]>>(
      `${API_URLS.COMPANY.GET_MACHINES_BY_ID}/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching machines by company ID:", error);
    throw error;
  }
};

export const attachMachine = async (
  params: MachineParams
): Promise<ApiResponse<AttachMachineResponse>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.post<ApiResponse<AttachMachineResponse>>(
      API_URLS.COMPANY.ATTACH_MACHINE,
      params,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error attaching machine:", error);
    throw error;
  }
};

export const detachMachine = async (
  company_machine_id: string
): Promise<ApiResponse<null>> => {
  const token = getAuthToken();

  try {
    const response = await apiClient.delete<ApiResponse<null>>(
      API_URLS.COMPANY.DETACH_MACHINE,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: { company_machine_id: company_machine_id },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error detaching machine:", error);
    throw error;
  }
};
